<template>
  <div>
    <modal id="edit-vendor-services">
      <template slot="header">Edit Vendor Services</template>
      <div class="card">
        <div class="card-body services-container" :class="{ disabled: saving }">
          <div class="text-center" v-if="!vendorServices.length">
            No services attached to this vendor yet.
          </div>
          <ul
            class="service-items d-flex flex-wrap p-0 mb-0"
            v-if="vendorServices.length"
          >
            <li
              class="service-item col-12 col-sm-6 col-md-6 d-flex align-items-center justify-content-center"
              v-for="service in vendorServices"
              :key="service.id"
            >
              <div
                class="service-item-container text-center d-flex w-100 align-items-center justify-content-center"
              >
                <i
                  class="fas fa-times-circle fa-lg remove-icon"
                  @click="!saving && removeService(service.id)"
                ></i>
                {{ service.name }}
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="row m-0 align-items-center">
        <div class="col-12 col-sm-10">
          <div class="form-group mb-0">
            <select
              :disabled="saving"
              v-model="selectedService"
              class="form-control"
            >
              <option :value="null">Select Service To Add</option>
              <option
                :value="s.id"
                v-for="s in notAttachedServices"
                :key="s.id"
              >
                {{ s.name }}
              </option>
            </select>
          </div>
        </div>
        <button
          @click="addService"
          :disabled="saving || !selectedService"
          class="btn btn-info pl-4 pr-4 mt-2 mt-sm-0"
        >
          <span v-if="!addingService">Add</span>
          <span
            class="spinner-border spinner-border-sm"
            v-if="addingService"
            role="status"
            aria-hidden="true"
          ></span>
        </button>
      </div>
    </modal>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "EditVendorServices",
  props: {
    vendorId: {
      type: Number,
      required: true,
    },
    vendorServices: {
      type: Array,
      required: true,
    },
    allServices: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      selectedService: null,
      addingService: false,
    };
  },
  computed: {
    ...mapState(["saving"]),
    notAttachedServices: function () {
      if (this.vendorServices.length) {
        const vendorServicesIds = this.vendorServices.map(
          (service) => service.id
        );
        return this.sortAlphabetically(
          this.allServices.filter(
            (service) => !vendorServicesIds.includes(service.id)
          )
        );
      }
      return this.sortAlphabetically(this.allServices);
    },
  },
  methods: {
    addService: function () {
      this.addingService = true;
      this.$store.commit("SET_SAVING_STATE", true);
      this.$store
        .dispatch("vendors/attachService", {
          vendorId: this.vendorId,
          serviceId: this.selectedService,
        })
        .then((result) => {
          this.addingService = false;
          if (result) {
            this.selectedService = null;
            this.$store.dispatch("vendors/getWithoutLoading", this.vendorId);
          }
        });
    },
    removeService: function (id) {
      this.$store.commit("SET_SAVING_STATE", true);
      this.$store
        .dispatch("vendors/detachService", {
          vendorId: this.vendorId,
          serviceId: id,
        })
        .then((result) => {
          if (result) {
            this.$store.dispatch("vendors/getWithoutLoading", this.vendorId);
          }
        });
    },
    sortAlphabetically(arrayInput) {
      const arraySrc = new Array(...arrayInput);
      const result = arraySrc.sort((a, b) => {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
      return result;
    },
  },
};
</script>

<style scoped>
.services-container {
  max-height: 200px;
  overflow-y: auto;
}
.services-container.disabled {
  opacity: 0.5;
}

.service-item {
  padding: 3px;
}
.service-item-container {
  position: relative;
  height: 100%;
  background-color: #5c6bc0;
  color: #fff;
  border-radius: 4px;
  padding: 10px;
  padding-left: 29px;
  font-size: 0.85em;
}
.disabled .remove-icon {
  cursor: not-allowed;
}
.remove-icon {
  cursor: pointer;
  position: absolute;
  left: 8px;
}
</style>
